import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { BrMaskerModule } from 'br-mask';

import { UiCAccountBalanceModule } from '@wlp/ui-c-account-balance';
import {UiCPaymentExtractModule} from '@wlp/ui-c-payment-extract';
import { UiCPaymentResumeModule } from '@wlp/ui-c-payment-resume';
import { UiCBarInfoModule } from '@wlp/ui-c-bar-info';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { HeaderUserInfoModule } from '@wlp/ui-c-header-user-info';
import { UiCPdfGeneratorModule } from '@wlp/ui-c-pdf-generator';
import {InterceptService} from "../../../../../../core/intercept/intercept.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";

import { ComponentsModule } from 'src/app/core/shared/modules/components.module';
import { ExtractInvestingRoutingModule } from './extract-investing-routing.module';

import { UiCPaymentReceiptComponent, UiCPaymentReceiptModule } from '@wlp/ui-c-payment-receipt';
import { CurrentPage } from './current/current.page';
import { HistoricalMovementModule } from './historical-movements/historical-movements.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule,
    RouterModule,
    ExtractInvestingRoutingModule,
    UiCAccountBalanceModule,
    BrMaskerModule,
    ReactiveFormsModule,
    UiCPaymentResumeModule,
    UiCPaymentExtractModule,
    UiCBarInfoModule,
    UiBsTranslateModule,
    HeaderUserInfoModule,
    UiCPdfGeneratorModule,
    UiCPaymentReceiptModule,
    HistoricalMovementModule
  ],
  declarations: [
    CurrentPage
  ],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
  entryComponents: [],
  bootstrap: [],
})
export class ExtractInvestingModule { }
